<template>
        <img :class="annot.type"
             :id="annot.id"
             :style="data.styleRect"
             :src="`${bookInfoState.publicPath}/${annot.imgSrc}`"
             class="no-select"
        >
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import cssvar from '@/scss/_variables.scss';
    import {usePaging} from "@/modules/reader/book/paging";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";

    const colorRect = cssvar.colorRect;
    const {pageResizeState} = usePageResize();
    const {getResizedAnnotationPos} = useAnnotationHelper();

    export default {
        props: {
            annot:Object,
            pagenum:Number
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { setCurrentPage} = usePaging();
            const { bookInfoState} = useBookInfo();
            const { karaokeState } = useKaraokeControl();
            const {playBlockState} = usePlayBlockControl();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    let resizedDomPos = getResizedAnnotationPos(domPos);

                    return {
                        ...resizedDomPos,
                        top: domPos.top < 0 ? 0 : resizedDomPos.top, //adjust for displacement problem...
                        height:"auto",
                        position:"absolute",
                        display: isShow.value ? "block" : "none"
                    }

                }),
            });

            const isShow = ref(true);

            watchEffect(() => {

                let isPlayingKaraoke =  karaokeState.activeGrouptag || playBlockState.id || playBlockState.spanSrc;

                if (props.annot.type === "hanzi") {

                        if (!bookInfoState.localHanVisible[props.pagenum]) {
                            bookInfoState.localHanVisible[props.pagenum] = {}
                        }

                        if (karaokeState.activeGrouptag === props.annot.grouptag) {
                            isShow.value = true;
                        } else {
                            if (bookInfoState.localHanVisible[props.pagenum][props.annot.id] === undefined) {
                                //if there is no toggle han buttons on the page, the han word should show when playing karaoke/span/block
                                if (isPlayingKaraoke) {
                                    isShow.value = true;
                                    //otherwise, just simply toggle
                                } else {
                                    isShow.value = bookInfoState.globalHanVisible;
                                }
                            } else {
                                if (isPlayingKaraoke) {
                                    isShow.value = true;
                                } else {
                                    isShow.value = bookInfoState.localHanVisible[props.pagenum][props.annot.id]
                                }

                            }
                        }


                } else if (props.annot.type === "pinyin") {

                    if (!bookInfoState.localPinYinVisible[props.pagenum]) {
                        bookInfoState.localPinYinVisible[props.pagenum] = {}
                    }

                    if (karaokeState.activeGrouptag === props.annot.grouptag) {
                        isShow.value = true;
                    } else {
                        if (bookInfoState.localPinYinVisible[props.pagenum][props.annot.id] === undefined) {
                            //if there is no toggle pin buttons on the page, the pin word should show when playing karaoke/span/block
                            if (isPlayingKaraoke) {
                                isShow.value = true;
                           //otherwise, just simply toggle
                            } else {
                                isShow.value = bookInfoState.globalPinYinVisible;
                            }
                        } else {
                            if (isPlayingKaraoke) {
                                isShow.value = true;
                            } else {
                                isShow.value = bookInfoState.localPinYinVisible[props.pagenum][props.annot.id];
                            }
                        }
                    }

                }

            });

            return {
                data,
                isShow,
                props,
                parserState,
                bookInfoState,
                setCurrentPage,
                getResizedAnnotationPos
            }

        }
    }

 </script>


<style scoped lang="scss">

</style>